// Generated by CoffeeScript 1.11.0
(function () {
  var DLList;

  DLList = function () {
    function DLList() {
      this._first = null;
      this._last = null;
      this.length = 0;
    }

    DLList.prototype.push = function (value) {
      var node;
      this.length++;
      node = {
        value: value,
        next: null
      };

      if (this._last != null) {
        this._last.next = node;
        this._last = node;
      } else {
        this._first = this._last = node;
      }

      return void 0;
    };

    DLList.prototype.shift = function () {
      var ref1, value;

      if (this._first == null) {
        return void 0;
      } else {
        this.length--;
      }

      value = this._first.value;
      this._first = (ref1 = this._first.next) != null ? ref1 : this._last = null;
      return value;
    };

    DLList.prototype.getArray = function () {
      var node, ref, results;
      node = this._first;
      results = [];

      while (node != null) {
        results.push((ref = node, node = node.next, ref.value));
      }

      return results;
    };

    return DLList;
  }();

  module.exports = DLList;
}).call(this);